/**
 * `data-instance` value for a create surface: `create-contact`,
 * `create-org-project`, … Shared by the provider's `SlideoutMenu` and the
 * form's own root so e2e can target either by the same handle.
 */
export function createSlideoutInstance(entityType: string): string {
  return `create-${entityType.replace(/^ahoy_/, '').replace(/_/g, '-')}`;
}
